<template>
    <CheckIn
        :title="`${$t('form.label.forecast')}`"
        @update-parent="updateParentEmitter"
    ></CheckIn>
</template>
<script>
import CheckIn from '../checkin/'

export default {
    name: 'CheckInProjection',
    components: {
        CheckIn,
    },
    methods: {
        updateParentEmitter(event) {
            this.$emit('update-parent', event)
        },
    },
}
</script>
